import { FC } from 'react';
import { useAppSelector } from '../../redux/hooks';
import { selectedStudentSkillStates } from '../../redux/reducers/studentSkillsSlice';
import { isSkillCompleted } from '../../businessLogicService/skillCompletionUtils';
import { TargetSkillTypeLabel } from '../../models/TargetSkillType';
import { UnitCompletedPill } from './UnitCompletedPill';

// Banner shown once the whole unit is complete: the pill-shaped UnitCompletedPill horizontally centered.
// When every Target skill is passed the pill lights up in the unit's colors; otherwise it keeps the
// default stone (locked-connector) look.
export const DashboardCompletedBanner: FC = () => {
  const studentSkills = useAppSelector(selectedStudentSkillStates);

  const targetSkills = (studentSkills ?? []).filter(skill => skill.targetSkillType === TargetSkillTypeLabel.TARGET);
  const allTargetsPassed = targetSkills.length > 0 && targetSkills.every(isSkillCompleted);

  return (
    <div className="tw-flex tw-w-full tw-justify-center tw-bg-neutral-50 tw-mt-8 tw-py-8 tw-rounded-b-3xl">
      <UnitCompletedPill tinted={allTargetsPassed} />
    </div>
  );
};
